import api from '../config/api.mkapi';
import creatHttp from '../utils/apiFactory';
const HTTPAPI = {};
for (let [key, item] of Object.entries(api)) {
  HTTPAPI[key] = creatHttp(item.url, item.method, $$mkapi_perpetual);
}

export default HTTPAPI;
